import { render, staticRenderFns } from "./searches.vue?vue&type=template&id=35912dbe"
import script from "./searches.vue?vue&type=script&lang=js"
export * from "./searches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports